<script setup>
import VueApexCharts from 'vue3-apexcharts';

const props = defineProps({
  // 분기별 에너지 데이터 [1분기, 2분기, 3분기, 4분기]
  data: {
    type: Array,
    default: () => [0, 0, 0, 0],
  },
  isMobile: {
    type: Boolean,
    default: false,
  },
});

// 분기별 색상
const quarterColors = {
  1: '#5790FC',
  2: '#FF6E6E',
  3: '#F3AE11',
  4: '#88C34A',
};

const categories = ['1분기', '2분기', '3분기', '4분기'];

const series = computed(() => [
  {
    name: '에너지',
    data: props.data,
  },
]);

const chartOptions = computed(() => ({
  chart: {
    type: 'line',
    toolbar: { show: false },
    zoom: { enabled: false },
    parentHeightOffset: 0,
    animations: {
      enabled: false,
    },
  },
  colors: ['#f80'],
  stroke: {
    width: 3,
    curve: 'straight', // 직선
  },
  markers: {
    size: 4,
    colors: ['#fff'],
    strokeColors: '#f80',
    strokeWidth: 2,
  },
  xaxis: {
    categories,
    axisTicks: { show: false },
    axisBorder: { show: false },
    tickPlacement: 'between',
    labels: {
      style: {
        colors: [quarterColors[1], quarterColors[2], quarterColors[3], quarterColors[4]],
        fontFamily: 'Pretendard',
        fontSize: '14px',
        fontWeight: '700',
      },
    },
  },
  yaxis: {
    min: 0,
    max: 100,
    tickAmount: 4,
    labels: {
      show: false,
    },
  },
  grid: {
    borderColor: '#EBEBEB',
    strokeDashArray: 0,
    padding: {
      top: 0,
      bottom: 0,
    },
  },
  dataLabels: {
    enabled: false,
  },
  tooltip: {
    enabled: true,
    y: {
      formatter: (val) => `${val}%`,
    },
  },
}));
</script>

<template>
  <div class="yearly-energy-chart">
    <VueApexCharts
      type="line"
      :height="props.isMobile ? 200 : 250"
      :options="chartOptions"
      :series="series"
    />
  </div>
</template>

<style scoped lang="scss">
.yearly-energy-chart {
  width: 100%;

  // 라인이 왼쪽에서 오른쪽으로 그려지는 애니메이션
  :deep(.apexcharts-line-series path) {
    stroke-dasharray: 2000;
    stroke-dashoffset: 2000;
    animation: draw-line 2.5s linear forwards;
  }

  // 마커 - 라인 완료 후 일괄 페이드인
  :deep(.apexcharts-series-markers) {
    opacity: 0;
    animation: fade-in 0.5s ease forwards 0.3s;
  }
}

@keyframes draw-line {
  to {
    stroke-dashoffset: 0;
  }
}

@keyframes fade-in {
  to {
    opacity: 1;
  }
}
</style>
